module.exports = __webpack_public_path__ + "static/ogp-contact-cce22ac6a511c524bc81522523bc2170.png";